/** @jsx h */
import { h } from 'preact'

// Deprecated component. use UserProfile instead
const Profile = ({ profile }) => {
  const { name, avatarUrl } = profile

  return (
    <div class='ClaimCard-profile'>
      <div class='Avatar Avatar--xxsmall'>
        <div class='Avatar-inner'>
          <img src={avatarUrl} class='Avatar-media' alt='' />
        </div>
      </div>
      <p class='ClaimCard-profileName CaptionUI--regular'>{name}</p>
    </div>
  )
}

export default Profile
